import React from 'react'
import styles from './style.module.css'

const Modal = ({
  children,
  onCancelModal,
  onSuccessModal,
  title,
  titleCenter,
  buttons,
  stylesContentAdd,
  stylesAdd
}) => {
  return (
    <div className={`${styles['w3-modal']} ${styles['show-modal-beneficiaries']}`}
      style={stylesContentAdd !== undefined ? stylesContentAdd : null}>
      <div className={styles['w3-modal-content']} style={stylesAdd !== undefined ? stylesAdd : null}>
        <div className={styles['w3-header']}></div>
        <div className={styles['w3-container']}>
          <p className={styles['w3title']} style={titleCenter ? { textAlign: 'center' } : {}}>
            {title}
          </p>
          {children}
          <div className={styles['w3areabtn']}>
            <button
              type='button'
              className={styles['btn-pago-accion']}
              onClick={onSuccessModal}
            >
              {buttons[0]}
            </button>
            <button
              type='button'
              className={`${styles['btn-cancelar']} ${styles['w3-margen']}`}
              onClick={onCancelModal}
            >
              {buttons[1]}
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Modal
